import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../assets/css/admin/adminNavbar.css";

function AdminNavbar() {

    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (

        <header className="admin-navbar">

            {/* LOGO */}
            <div className="admin-logo">

                <img
                    src={`${process.env.PUBLIC_URL}/logo.png`}
                    alt="StoryLine Studios"
                />

                <div className="admin-logo-text">

                    <h2>StoryLine Studios</h2>

                    <span>Admin Panel</span>

                </div>

            </div>


            {/* HAMBURGER */}
            <button
                type="button"
                className={`admin-hamburger ${menuOpen ? "active" : ""}`}
                onClick={() => setMenuOpen(prev => !prev)}
                aria-label="Toggle admin navigation"
                aria-expanded={menuOpen}
            >

                <span></span>
                <span></span>
                <span></span>

            </button>


            {/* NAVIGATION */}
            <nav
                className={`admin-nav ${menuOpen ? "nav-open" : ""}`}
            >

                <ul>

                    <li>
                        <Link
                            to="/admin/layout"
                            onClick={closeMenu}
                        >
                            Dashboard
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/admin/home"
                            onClick={closeMenu}
                        >
                            Home
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/admin/about"
                            onClick={closeMenu}
                        >
                            About
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/admin/gallery"
                            onClick={closeMenu}
                        >
                            Gallery
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/admin/packages"
                            onClick={closeMenu}
                        >
                            Packages
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/admin/feedbackPage"
                            onClick={closeMenu}
                        >
                            Feedback
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/admin/contactpage"
                            onClick={closeMenu}
                        >
                            Contact
                        </Link>
                    </li>

                </ul>

            </nav>

        </header>

    );

}

export default AdminNavbar;